import { PricingStructure as PricingStructureComponent } from './components';
import { PricingStructureFallback } from './components/fallback';

export const PricingStructure = Object.assign(PricingStructureComponent, {
  Fallback: PricingStructureFallback
});
